
import { Locale } from '@type/locale';

export class I18nString {

    i18nStringId: string;
    locale: Locale;
    value: string;
}
